<mat-paginator [hidden]="!showMatPaginator" [className]="matClass"></mat-paginator>
<div *ngIf="showLabel" [className]="paginatorLabelClass" class="pagination-label">Showing {{ paginatorIntl.getRangeLabel(paginator.pageIndex, paginator.pageSize, paginator.length) }} entries</div>	
<div *ngIf="showPaginator" [className]="paginatorClass">
	<ul class="pagination">
		<li *ngFor="let item of pages; let i = index" class="page-item" [ngClass]="{'active': item.active}">
			<a class="page-link" href="#" (click)="goToPage(item.pageIndex)">{{item.label}}</a>
		</li>			
	</ul>
</div>